// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pswp__custom-caption[data-v-7f1818a4]{background:rgba(13,71,161,.75);font-size:16px;color:#fff;width:calc(100% - 32px);max-width:400px;padding:7px 14px;border-radius:4px;position:absolute;left:50%;bottom:16px;transform:translateX(-50%)}.pswp__custom-caption a[data-v-7f1818a4]{color:#fff;text-decoration:underline}.pswp__custom-caption.hidden[data-v-7f1818a4]{display:none}", ""]);
// Exports
module.exports = exports;
